import {
  SET_EMAIL_LIST,
  SET_SHOW_EMAIL_LIST,
  SET_SELECTED_MAIL,
  SET_MENTION_LIST,
  SET_MAIL_TYPE,
  SET_EMAIL_LIST_OPTIONS,
  SET_FROM_EMAIL_LIST_OPTIONS,
  SET_EMAIL_TEMPLATE,
  SET_SUPERVISORAPPROVE,
  SET_EMAIL_ATTACHMENT,
  SET_COMPOSE_EMAIL_ATTACHMENT,
  SET_FORWARDED_EMAIL_LIST,
} from "../../Redux/Actions/type";

const initialState1 = {
  mailList: [],
  showEmailList: true,
  selectedMail: {},
  mentionlist: [],
  mailType: "Replay",
  emailListOption: [],
  templatelist: "",
  supervisorApprove: "",
  attachment: [],
  composeAttachment: [],
  forwardedMailList: [],
  fromEmailList: [],
  isReschedule: false,
};

export const emailReducer = (state = initialState1, action) => {
  switch (action.type) {
    case SET_FORWARDED_EMAIL_LIST:
      return {
        ...state,
        forwardedMailList: action.val,
      };

    case SET_FROM_EMAIL_LIST_OPTIONS:
      return {
        ...state,
        fromEmailList: action.val,
      };

    case SET_EMAIL_LIST:
      return {
        ...state,
        mailList: action.val,
      };
    case SET_COMPOSE_EMAIL_ATTACHMENT:
      return {
        ...state,
        composeAttachment: action.val,
      };
    case SET_EMAIL_ATTACHMENT:
      return {
        ...state,
        attachment: action.val,
      };
    case SET_EMAIL_TEMPLATE:
      return {
        ...state,
        templatelist: action.val,
      };
    case SET_SUPERVISORAPPROVE:
      return {
        ...state,
        supervisorApprove: action.val,
      };
    case SET_EMAIL_LIST_OPTIONS:
      return {
        ...state,
        emailListOption: action.val,
      };
    case SET_MAIL_TYPE:
      return {
        ...state,
        mailType: action.val,
      };
    case SET_SHOW_EMAIL_LIST:
      return {
        ...state,
        showEmailList: action.val,
      };
    case SET_SELECTED_MAIL:
      return {
        ...state,
        selectedMail: action.val,
      };

    case SET_MENTION_LIST:
      return {
        ...state,
        mentionlist: action.val,
      };
    default:
      return state;
  }
};
